import { GET_PROJECT_BY_ID } from "constants/projects";

export default (state = null, action) => {
  switch (action.type) {
    case `${GET_PROJECT_BY_ID}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
